// FILE: src/components/QuickLinksCard.js
//
// Coach rail navigation card. Folds the deprecated dashboard regions
// (study plan, milestones, performance history, readiness detail) plus
// the Recalibrate baseline action into a single, persistent menu so
// they don't take up primary-column real estate.

import React, { useState } from 'react';
import styles from './QuickLinksCard.module.css';

export default function QuickLinksCard({ onNavigate, onRecalibrate }) {
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);

  async function go() {
    if (!onRecalibrate) return;
    setBusy(true);
    try { await onRecalibrate(); }
    finally { setBusy(false); setConfirm(false); }
  }

  return (
    <div className={styles.card} data-testid="dashboard-quick-links">
      <div className={styles.head}>Quick Links</div>
      <ul className={styles.list}>
        <li>
          <button type="button" onClick={() => onNavigate?.('plan')} data-testid="dashboard-link-plan">
            📋 Study plan
          </button>
        </li>
        <li>
          <button type="button" onClick={() => onNavigate?.('milestones')} data-testid="dashboard-link-milestones">
            🏆 Milestones
          </button>
        </li>
        <li>
          <button type="button" onClick={() => onNavigate?.('history')} data-testid="dashboard-link-history">
            📊 Performance history
          </button>
        </li>
        <li>
          <button type="button" onClick={() => onNavigate?.('readiness')} data-testid="dashboard-link-readiness">
            📈 Readiness details
          </button>
        </li>
        <li>
          {!confirm ? (
            <button
              type="button"
              onClick={() => setConfirm(true)}
              data-testid="dashboard-link-recalibrate"
            >↻ Recalibrate baseline</button>
          ) : (
            <div className={styles.confirm}>
              <div className={styles.confirmCopy}>
                Recalibrating sets a new baseline — past sessions stay in your history.
              </div>
              <div className={styles.confirmActions}>
                <button
                  type="button"
                  className={styles.confirmGo}
                  onClick={go}
                  disabled={busy}
                  data-testid="dashboard-recalibrate-confirm"
                >{busy ? 'Recalibrating…' : 'Recalibrate'}</button>
                <button
                  type="button"
                  className={styles.confirmCancel}
                  onClick={() => setConfirm(false)}
                  disabled={busy}
                >Cancel</button>
              </div>
            </div>
          )}
        </li>
      </ul>
    </div>
  );
}
